<template>
  <div class="row center-xs middle-xs pt-20 mb-12">
    <img src="/static/logos/parlay_logo.svg" style="height: 180px" alt="" />
    <div v-if="environment_is_staging" class="col-xs-12">
      <span>THIS IS THE STAGING ENVIRONMENT</span>
      <br />
      <a href="https://go.parlayideas.com"
        >Please access the official Parlay app by clicking here</a
      >
    </div>
  </div>
</template>
<!--
  JAVASCRIPT
-->
<script lang="babel">
  import { environment } from 'services/apiConfigs';

  export default {
    data() {
      return {
      };
    },
    computed: {
      environment_is_staging() {
        return environment === 'staging' || environment === 'staging_two' ;
      },
    },
    props: [],
  };
</script>
<!--
  CSS
-->
<style lang="scss"></style>



// WEBPACK FOOTER //
// landingPageTitle.vue?6bcda740